import * as images from './images'

export const songList = [
	/*August Burns Red Albums*/
	{
		id: 10000 /*id of the album*/,
		cover: images.augustburnsred2,
		year: 2026,
		album: 'Season of Surrender',
		albumSongs: [
			{ id: 1, title: 'Legions (feat. Mike Hranica)', length: '4:18' },
			{ id: 2, title: 'The Nameless', length: '2:54' },
			{ id: 3, title: 'Behemoth', length: '3:39' },
			{ id: 4, title: 'Den of Thieves', length: '4:12' },
			{ id: 5, title: 'Sonic Salvation (feat. Jamie Hails)', length: '4:13' },
			{ id: 6, title: 'Cerebral Malfunction (feat. Make Them Suffer)', length: '4:47' },
			{ id: 7, title: 'Tear of the Clouds', length: '0:42' },
			{ id: 8, title: 'Whispers Like Splinters', length: '3:48' },
			{ id: 9, title: 'S.O.S.', length: '4:27' },
			{ id: 10, title: 'New Horizons', length: '5:02' },
			{ id: 11, title: 'Forged by Failure', length: '6:45' },
		],
	},

	{
		id: 10001 /*id of the album*/,
		cover: images.augustburnsred1,
		year: 2023,
		album: 'Death Below',
		albumSongs: [
			{ id: 1, title: 'Premonition', length: '1:53' },
			{ id: 2, title: 'The Cleansing', length: '7:47' },
			{ id: 3, title: 'Ancestry (feat. Jesse Leach)', length: '4:50' },
			{ id: 4, title: 'Tightrope (feat. Jason Richardson)', length: '4:13' },
			{ id: 5, title: "Fool's Gold in the Bear Trap", length: '3:04' },
			{ id: 6, title: 'Backfire', length: '4:22' },
			{ id: 7, title: 'Revival', length: '4:29' },
			{ id: 8, title: 'Sevink', length: '1:23' },
			{ id: 9, title: 'Dark Divide', length: '4:58' },
			{ id: 10, title: 'Deadbolt', length: '4:20' },
			{ id: 11, title: 'The Abyss (feat. JT Cavey)', length: '4:34' },
			{ id: 12, title: 'Reckoning (feat. Spencer Chamberlain)', length: '7:52' },
		],
	},
	{
		id: 10002,
		cover: images.augustburnsred3,
		year: 2020,
		album: 'Guardians',
		albumSongs: [
			{ id: 1, title: 'The Narrative', length: '4:09' },
			{ id: 2, title: 'Bones', length: '4:15' },
			{ id: 3, title: 'Paramount', length: '4:48' },
			{ id: 4, title: 'Defender', length: '4:21' },
			{ id: 5, title: 'Lighthouse', length: '4:13' },
			{ id: 6, title: 'Dismembered Memory', length: '4:09' },
			{ id: 7, title: 'Ties That Bind', length: '4:18' },
			{ id: 8, title: 'Bloodletter', length: '3:40' },
			{ id: 9, title: 'Extinct By Instinct', length: '4:43' },
			{ id: 10, title: 'Empty Heaven', length: '4:25' },
			{ id: 11, title: 'Three Fountains', length: '6:21' },
		],
	},
	{
		id: 10003,
		cover: images.augustburnsred4,
		year: 2017,
		album: 'Phantom Anthem',
		albumSongs: [
			{ id: 1, title: 'King of Sorrow', length: '4:05' },
			{ id: 2, title: 'Hero of the Half Truth', length: '5:03' },
			{ id: 3, title: 'The Frost', length: '4:46' },
			{ id: 4, title: 'Lifeline', length: '5:34' },
			{ id: 5, title: 'Invisible Enemy', length: '4:37' },
			{ id: 6, title: 'Quake', length: '4:08' },
			{ id: 7, title: 'Coordinates', length: '5:11' },
			{ id: 8, title: 'Generations', length: '6:00' },
			{ id: 9, title: 'Float', length: '4:15' },
			{ id: 10, title: 'Dangerous', length: '4:23' },
			{ id: 11, title: 'Carbon Copy', length: '5:39' },
		],
	},

	{
		id: 10004,
		cover: images.augustburnsred5,
		year: 2015,
		album: 'Found in Far Away Places',
		albumSongs: [
			{ id: 1, title: 'The Wake', length: '3:26' },
			{ id: 2, title: 'Martyr', length: '4:35' },
			{ id: 3, title: 'Identity', length: '4:19' },
			{ id: 4, title: 'Separating the Seas', length: '4:19' },
			{ id: 5, title: 'Ghosts', length: '4:49' },
			{ id: 6, title: 'Majoring in the Minors', length: '4:18' },
			{ id: 7, title: 'Everlasting Ending', length: '5:09' },
			{ id: 8, title: 'Broken Promises', length: '6:12' },
			{ id: 9, title: 'Blackwood', length: '4:42' },
			{ id: 10, title: 'Twenty-One Grams', length: '4:53' },
			{ id: 11, title: 'Vanguard', length: '5:39' },
		],
	},

	{
		id: 10005,
		cover: images.augustburnsred6,
		year: 2013,
		album: 'Rescue & Restore',
		albumSongs: [
			{ id: 1, title: 'Provision', length: '4:40' },
			{ id: 2, title: 'Treatment', length: '5:14' },
			{ id: 3, title: 'Spirit Breaker', length: '4:51' },
			{ id: 4, title: 'Count It All As Lost', length: '4:09' },
			{ id: 5, title: 'Sincerity', length: '3:17' },
			{ id: 6, title: 'Creative Captivity', length: '4:42' },
			{ id: 7, title: 'Fault Line', length: '4:03' },
			{ id: 8, title: 'Beauty In Tragedy', length: '4:51' },
			{ id: 9, title: 'Animals', length: '3:29' },
			{ id: 10, title: 'Echoes', length: '4:23' },
			{ id: 11, title: 'The First Step', length: '4:24' },
		],
	},
	{
		id: 10007,
		cover: images.augustburnsred8,
		year: 2011,
		album: 'Leveler',
		albumSongs: [
			{ id: 1, title: 'Empire', length: '3:49' },
			{ id: 2, title: 'Internal Cannon', length: '5:05' },
			{ id: 3, title: 'Divisions', length: '3:20' },
			{ id: 4, title: 'Cutting the Ties', length: '5:02' },
			{ id: 5, title: 'Pangaea', length: '6:22' },
			{ id: 6, title: 'Carpe Diem', length: '5:37' },
			{ id: 7, title: '40 Nights', length: '3:54' },
			{ id: 8, title: 'Salt & Light', length: '3:40' },
			{ id: 9, title: 'Poor Millionaire', length: '4:28' },
			{ id: 10, title: '01/16/2011', length: '0:52' },
			{ id: 11, title: 'Boys of Fall', length: '4:01' },
			{ id: 12, title: 'Leveler', length: '4:47' },
		],
	},
	{
		id: 10008,
		cover: images.augustburnsred9,
		year: 2009,
		album: 'Constellations',
		albumSongs: [
			{ id: 1, title: 'Thirty and Seven', length: '3:19' },
			{ id: 2, title: 'Existence', length: '3:54' },
			{ id: 3, title: 'Ocean of Apathy', length: '3:57' },
			{ id: 4, title: 'White Washed', length: '3:46' },
			{ id: 5, title: 'Marianas Trench', length: '4:18' },
			{ id: 6, title: 'The Escape Artist', length: '3:58' },
			{ id: 7, title: 'Indonesia', length: '3:34' },
			{ id: 8, title: 'Paradox', length: '3:19' },
			{ id: 9, title: 'Meridian', length: '6:00' },
			{ id: 10, title: 'Rationalist', length: '2:39' },
			{ id: 11, title: 'Meddler', length: '3:54' },
			{ id: 12, title: 'Crusades', length: '5:12' },
		],
	},
	{
		id: 10009,
		cover: images.augustburnsred10,
		year: 2007,
		album: 'Messengers',
		albumSongs: [
			{ id: 1, title: 'The Truth of a Liar', length: '4:12' },
			{ id: 2, title: 'Up Against the Ropes', length: '5:04' },
			{ id: 3, title: 'Back Burner', length: '3:42' },
			{ id: 4, title: 'The Blinding Light', length: '5:28' },
			{ id: 5, title: 'Composure', length: '4:13' },
			{ id: 6, title: 'Vital Signs', length: '3:17' },
			{ id: 7, title: 'The Eleventh Hour', length: '4:05' },
			{ id: 8, title: 'The Balance', length: '3:20' },
			{ id: 9, title: 'Black Sheep', length: '3:53' },
			{ id: 10, title: 'An American Dream', length: '4:41' },
			{ id: 11, title: 'Redemption', length: '6:12' },
		],
	},
	{
		id: 10010,
		cover: images.augustburnsred11,
		year: 2005,
		album: 'Thrill Seeker',
		albumSongs: [
			{ id: 1, title: 'Your Little Suburbia Is in Ruins', length: '3:58' },
			{ id: 2, title: 'Speech Impediment', length: '4:01' },
			{ id: 3, title: 'Endorphins', length: '3:10' },
			{ id: 4, title: 'Too Late for Roses', length: '3:19' },
			{ id: 5, title: 'Barbarian', length: '3:45' },
			{ id: 6, title: 'The Reflective Property', length: '3:51' },
			{ id: 7, title: 'A Wish Full of Dreams', length: '2:58' },
			{ id: 8, title: 'Consumer', length: '4:10' },
			{ id: 9, title: 'A Shot Below the Belt', length: '4:10' },
			{ id: 10, title: 'Eve of the End', length: '3:09' },
			{ id: 11, title: 'The Seventh Trumpet', length: '8:12' },
		],
	},

	/*Black Sabbath Albums*/
	{
		id: 10028 /*id of the album*/,
		cover: images.blacksabbath1,
		year: 1980,
		album: 'Heaven and Hell',
		albumSongs: [
			{ id: 1, title: 'Neon Knights', length: '3:49' },
			{ id: 2, title: 'Children of the Sea', length: '4:12' },
			{ id: 3, title: 'Lady Evil', length: '3:25' },
			{ id: 4, title: 'Heaven and Hell', length: '5:00' },
			{ id: 5, title: 'Wishing Well', length: '3:30' },
			{ id: 6, title: 'Die Young', length: '4:05' },
			{ id: 7, title: 'Walk Away', length: '3:45' },
			{ id: 8, title: 'Lonely Is the Word', length: '4:30' },
		],
	},
	{
		id: 10020 /*id of the album*/,
		cover: images.blacksabbath2,
		year: 1970,
		album: 'black Sabbath',
		albumSongs: [
			{ id: 1, title: 'Black Sabbath', length: '6:20' },
			{ id: 2, title: 'The Wizard', length: '4:24' },
			{ id: 3, title: 'Behind the Wall of Sleep', length: '3:06' },
			{ id: 4, title: 'N.I.B.', length: '6:08' },
			{ id: 5, title: 'Evil Woman', length: '3:25' },
			{ id: 6, title: 'Sleeping Village', length: '3:46' },
			{ id: 7, title: 'Warning', length: '10:32' },
		],
	},

	{
		id: 10021 /*id of the album*/,
		cover: images.blacksabbath3,
		year: 1970,
		album: 'Paranoid',
		albumSongs: [
			{ id: 1, title: 'War Pigs', length: '7:55' },
			{ id: 2, title: 'Paranoid', length: '2:48' },
			{ id: 3, title: 'Planet Caravan', length: '4:30' },
			{ id: 4, title: 'Iron Man', length: '5:57' },
			{ id: 5, title: 'Electric Funeral', length: '4:52' },
			{ id: 6, title: 'Hand of Doom', length: '7:08' },
			{ id: 7, title: 'Rat Salad', length: '2:30' },
			{ id: 8, title: 'Fairies Wear Boots', length: '6:15' },
		],
	},
	{
		id: 10022 /*id of the album*/,
		cover: images.blacksabbath9,
		year: 1971,
		album: 'Master of reality',
		albumSongs: [
			{ id: 1, title: 'Sweet Leaf', length: '5:05' },
			{ id: 2, title: 'After Forever', length: '5:27' },
			{ id: 3, title: 'Embryo', length: '0:28' },
			{ id: 4, title: 'Children of the Grave', length: '5:18' },
			{ id: 5, title: 'Orchid', length: '1:31' },
			{ id: 6, title: 'Lord of This World', length: '5:26' },
			{ id: 7, title: 'Solitude', length: '5:02' },
			{ id: 8, title: 'Into the Void', length: '6:12' },
		],
	},
	{
		id: 10023 /*id of the album*/,
		cover: images.blacksabbath4,
		year: 1972,
		album: 'Vol.4',
		albumSongs: [
			{ id: 1, title: 'Wheels of Confusion', length: '8:14' },
			{ id: 2, title: "Tomorrow's Dream", length: '3:12' },
			{ id: 3, title: 'Changes', length: '4:46' },
			{ id: 4, title: 'FX', length: '1:40' },
			{ id: 5, title: 'Supernaut', length: '4:43' },
			{ id: 6, title: 'Snowblind', length: '5:33' },
			{ id: 7, title: 'Cornucopia', length: '3:55' },
			{ id: 8, title: 'Laguna Sunrise', length: '2:56' },
			{ id: 9, title: "St. Vitus' Dance", length: '2:30' },
			{ id: 10, title: 'Under the Sun', length: '5:52' },
		],
	},
	{
		id: 10024 /*id of the album*/,
		cover: images.blacksabbath5,
		year: 1973,
		album: 'Sabbath Bloody Sabbath',
		albumSongs: [
			{ id: 1, title: 'Sabbath Bloody Sabbath', length: '5:45' },
			{ id: 2, title: 'A National Acrobat', length: '6:16' },
			{ id: 3, title: 'Fluff', length: '4:12' },
			{ id: 4, title: 'Sabbra Cadabra', length: '5:59' },
			{ id: 5, title: 'Killing Yourself to Live', length: '5:41' },
			{ id: 6, title: 'Who Are You?', length: '4:16' },
			{ id: 7, title: 'Looking for Today', length: '5:06' },
			{ id: 8, title: 'Spiral Architect', length: '5:29' },
		],
	},
	{
		id: 10025 /*id of the album*/,
		cover: images.blacksabbath7,
		year: 1975,
		album: 'Sabotage',
		albumSongs: [
			{ id: 1, title: 'Hole in the Sky', length: '4:00' },
			{ id: 2, title: "Don't Start (Too Late)", length: '0:49' },
			{ id: 3, title: 'Symptom of the Universe', length: '6:29' },
			{ id: 4, title: 'Megalomania', length: '9:46' },
			{ id: 5, title: 'The Thrill of It All', length: '5:55' },
			{ id: 6, title: 'Supertzar', length: '3:42' },
			{ id: 7, title: 'Am I Going Insane (Radio)', length: '4:15' },
			{ id: 8, title: 'The Writ', length: '8:44' },
		],
	},
	{
		id: 10027 /*id of the album*/,
		cover: images.blacksabbath8,
		year: 1976,
		album: 'Technical Ecstasy',
		albumSongs: [
			{ id: 1, title: 'Back Street Kids', length: '3:48' },
			{ id: 2, title: "You Won't Change Me", length: '6:37' },
			{ id: 3, title: "It's Alright", length: '3:59' },
			{ id: 4, title: 'Gypsy', length: '5:13' },
			{ id: 5, title: 'All Moving Parts (Stand Still)', length: '4:58' },
			{ id: 6, title: "Rock 'n' Roll Doctor", length: '3:25' },
			{ id: 7, title: "She's Gone", length: '4:52' },
			{ id: 8, title: 'Dirty Women', length: '7:55' },
		],
	},
	{
		id: 10029 /*id of the album*/,
		cover: images.blacksabbath10,
		year: 1978,
		album: 'Never Say Die!',
		albumSongs: [
			{ id: 1, title: 'Never Say Die', length: '3:50' },
			{ id: 2, title: 'Johnny Blade', length: '6:28' },
			{ id: 3, title: "Junior's Eyes", length: '6:41' },
			{ id: 4, title: 'A Hard Road', length: '6:04' },
			{ id: 5, title: 'Shock Wave', length: '5:13' },
			{ id: 6, title: 'Air Dance', length: '5:14' },
			{ id: 7, title: 'Over to You', length: '5:22' },
			{ id: 8, title: 'Breakout', length: '2:35' },
			{ id: 9, title: 'Swinging the Chain', length: '4:02' },
		],
	},
	{
		id: 10030 /*id of the album*/,
		cover: images.blacksabbath11,
		year: 1981,
		album: 'Mob Rules',
		albumSongs: [
			{ id: 1, title: 'Turn Up the Night', length: '3:42' },
			{ id: 2, title: 'Voodoo', length: '4:35' },
			{ id: 3, title: 'The Sign of the Southern Cross', length: '7:49' },
			{ id: 4, title: 'E5150', length: '2:53' },
			{ id: 5, title: 'The Mob Rules', length: '3:15' },
			{ id: 6, title: 'Country Girl', length: '4:02' },
			{ id: 7, title: 'Slipping Away', length: '3:45' },
			{ id: 8, title: 'Falling Off the Edge of the World', length: '5:02' },
			{ id: 9, title: 'Over and Over', length: '5:28' },
		],
	},
	{
		id: 10031 /*id of the album*/,
		cover: images.blacksabbath12,
		year: 1983,
		album: 'Born Again',
		albumSongs: [
			{ id: 1, title: 'Trashed', length: '4:16' },
			{ id: 2, title: 'Stonehenge', length: '1:58' },
			{ id: 3, title: 'Disturbing the Priest', length: '5:49' },
			{ id: 4, title: 'The Dark', length: '0:45' },
			{ id: 5, title: 'Zero the Hero', length: '7:35' },
			{ id: 6, title: 'Digital Bitch', length: '3:39' },
			{ id: 7, title: 'Born Again', length: '6:34' },
			{ id: 8, title: 'Hot Line', length: '4:53' },
			{ id: 9, title: 'Keep It Warm', length: '5:36' },
		],
	},
	{
		id: 10032 /*id of the album*/,
		cover: images.blacksabbath13,
		year: 1986,
		album: 'Seventh Star',
		albumSongs: [
			{ id: 1, title: 'In for the Kill', length: '3:43' },
			{ id: 2, title: 'No Stranger to Love', length: '4:28' },
			{ id: 3, title: 'Turn to Stone', length: '3:28' },
			{ id: 4, title: 'Sphinx (The Guardian)', length: '1:12' },
			{ id: 5, title: 'Seventh Star', length: '5:20' },
			{ id: 6, title: 'Danger Zone', length: '4:23' },
			{ id: 7, title: 'Heart Like a Wheel', length: '6:35' },
			{ id: 8, title: 'Angry Heart', length: '3:06' },
			{ id: 9, title: 'In Memory...', length: '2:35' },
		],
	},
	{
		id: 10033 /*id of the album*/,
		cover: images.blacksabbath14,
		year: 1987,
		album: 'The Eternal Idol',
		albumSongs: [
			{ id: 1, title: 'The Shining', length: '5:58' },
			{ id: 2, title: 'Ancient Warrior', length: '5:34' },
			{ id: 3, title: 'Hard Life to Love', length: '5:00' },
			{ id: 4, title: 'Glory Ride', length: '4:48' },
			{ id: 5, title: 'Born to Lose', length: '3:43' },
			{ id: 6, title: 'Nightmare', length: '5:17' },
			{ id: 7, title: 'Scarlet Pimpernel', length: '2:07' },
			{ id: 8, title: 'Lost Forever', length: '4:00' },
			{ id: 9, title: 'Eternal Idol', length: '6:35' },
		],
	},
	{
		id: 10034 /*id of the album*/,
		cover: images.blacksabbath15,
		year: 1989,
		album: 'Headless Cross',
		albumSongs: [
			{ id: 1, title: 'The Gates of Hell', length: '1:06' },
			{ id: 2, title: 'Headless Cross', length: '6:28' },
			{ id: 3, title: 'Devil & Daughter', length: '4:39' },
			{ id: 4, title: 'When Death Calls', length: '6:56' },
			{ id: 5, title: 'Kill in the Spirit World', length: '5:09' },
			{ id: 6, title: 'Call of the Wild', length: '5:18' },
			{ id: 7, title: 'Black Moon', length: '4:05' },
			{ id: 8, title: 'Nightwing', length: '6:32' },
		],
	},
	{
		id: 10035 /*id of the album*/,
		cover: images.blacksabbath16,
		year: 1990,
		album: 'TYR',
		albumSongs: [
			{ id: 1, title: 'Anno Mundi', length: '6:12' },
			{ id: 2, title: 'The Law Maker', length: '3:53' },
			{ id: 3, title: 'Jerusalem', length: '3:59' },
			{ id: 4, title: 'The Sabbath Stones', length: '6:46' },
			{ id: 5, title: 'The Battle of Tyr', length: '1:08' },
			{ id: 6, title: "Odin's Court", length: '2:42' },
			{ id: 7, title: 'Valhalla', length: '4:41' },
			{ id: 8, title: 'Feels Good to Me', length: '5:44' },
			{ id: 9, title: 'Heaven in Black', length: '4:05' },
		],
	},
	{
		id: 10036 /*id of the album*/,
		cover: images.blacksabbath17,
		year: 1992,
		album: 'Dehumanizer',
		albumSongs: [
			{ id: 1, title: 'Computer God', length: '6:10' },
			{ id: 2, title: 'After All (The Dead)', length: '5:37' },
			{ id: 3, title: 'TV Crimes', length: '3:58' },
			{ id: 4, title: 'Letters from Earth', length: '4:12' },
			{ id: 5, title: 'Master of Insanity', length: '5:54' },
			{ id: 6, title: 'Time Machine', length: '4:10' },
			{ id: 7, title: 'Sins of the Father', length: '4:43' },
			{ id: 8, title: 'Too Late', length: '6:54' },
			{ id: 9, title: 'I', length: '5:10' },
			{ id: 10, title: 'Buried Alive', length: '4:47' },
		],
	},
	{
		id: 10037 /*id of the album*/,
		cover: images.blacksabbath18,
		year: 1994,
		album: 'Cross Purposes',
		albumSongs: [
			{ id: 1, title: 'I Witness', length: '4:58' },
			{ id: 2, title: 'Cross of Thorns', length: '4:34' },
			{ id: 3, title: 'Psychophobia', length: '3:14' },
			{ id: 4, title: 'Virtual Death', length: '5:49' },
			{ id: 5, title: 'Immaculate Deception', length: '4:15' },
			{ id: 6, title: 'Dying for Love', length: '5:53' },
			{ id: 7, title: 'Back to Eden', length: '3:57' },
			{ id: 8, title: 'The Hand That Rocks the Cradle', length: '4:30' },
			{ id: 9, title: 'Cardinal Sin', length: '4:21' },
			{ id: 10, title: 'Evil Eye', length: '5:59' },
		],
	},
	{
		id: 10038 /*id of the album*/,
		cover: images.blacksabbath19,
		year: 1995,
		album: 'Forbidden',
		albumSongs: [
			{ id: 1, title: 'The Illusion of Power', length: '4:54' },
			{ id: 2, title: 'Get a Grip', length: '4:00' },
			{ id: 3, title: "Can't Get Close Enough", length: '4:29' },
			{ id: 4, title: 'Shaking Off the Chains', length: '4:04' },
			{ id: 5, title: "I Won't Cry for You", length: '4:48' },
			{ id: 6, title: 'Guilty as Hell', length: '3:29' },
			{ id: 7, title: 'Sick and Tired', length: '3:32' },
			{ id: 8, title: 'Rusty Angels', length: '5:01' },
			{ id: 9, title: 'Forbidden', length: '3:49' },
			{ id: 10, title: 'Kiss of Death', length: '6:10' },
		],
	},
	{
		id: 10039 /*id of the album*/,
		cover: images.blacksabbath20,
		year: 2013,
		album: '13',
		albumSongs: [
			{ id: 1, title: 'End of the Beginning', length: '8:02' },
			{ id: 2, title: 'God Is Dead?', length: '8:50' },
			{ id: 3, title: 'Loner', length: '5:00' },
			{ id: 4, title: 'Zeitgeist', length: '4:35' },
			{ id: 5, title: 'Age of Reason', length: '6:58' },
			{ id: 6, title: 'Live Forever', length: '4:46' },
			{ id: 7, title: 'Damaged Soul', length: '7:50' },
			{ id: 8, title: 'Dear Father', length: '7:05' },
			{ id: 9, title: 'Methademic', length: '5:58' },
			{ id: 10, title: 'Peace of Mind', length: '3:40' },
			{ id: 11, title: 'Pariah', length: '5:34' },
		],
	},

	/*BORGNARAK ALBUMS LIST*/

	{
		id: 10070,
		cover: images.borknagar12,
		year: 1996,
		album: 'Borknagar',
		albumSongs: [
			{ id: 1, title: 'Vintervredets Sjelesagn', length: '6:44' },
			{ id: 2, title: 'Tanker Mot Tind (Kvelding)', length: '3:29' },
			{ id: 3, title: 'Svartskogs Gilde', length: '5:52' },
			{ id: 4, title: 'Ved Steingard', length: '2:13' },
			{ id: 5, title: 'Krigsstev', length: '2:03' },
			{ id: 6, title: 'Dauden', length: '5:48' },
			{ id: 7, title: 'Grimskalle Trell', length: '5:38' },
			{ id: 8, title: 'Nord Naagauk', length: '3:06' },
			{ id: 9, title: 'Fandens Allheim', length: '6:19' },
			{ id: 10, title: 'Tanker Mot Tind (Gryning)', length: '2:56' },
		],
	},

	{
		id: 10071,
		cover: images.borknagar2,
		year: 1997,
		album: 'The Olden Domain',
		albumSongs: [
			{ id: 1, title: 'The Eye of Oden', length: '6:01' },
			{ id: 2, title: 'The Winterway', length: '7:52' },
			{ id: 3, title: 'Om Hundrede Aar Er Alting Glemt', length: '4:12' },
			{ id: 4, title: 'A Tale of Pagan Tongue', length: '6:13' },
			{ id: 5, title: 'To Mount and Rove', length: '4:56' },
			{ id: 6, title: 'Grimland Domain', length: '6:19' },
			{ id: 7, title: 'Ascension of Our Fathers', length: '3:54' },
			{ id: 8, title: 'The Dawn of the End', length: '5:06' },
		],
	},
	{
		id: 10072,
		cover: images.borknagar3,
		year: 1998,
		album: 'The Archaic Course',
		albumSongs: [
			{ id: 1, title: 'Oceans Rise', length: '5:27' },
			{ id: 2, title: 'Universal', length: '5:35' },
			{ id: 3, title: 'The Witching Hour', length: '4:26' },
			{ id: 4, title: 'The Black Token', length: '5:19' },
			{ id: 5, title: 'Nocturnal Vision', length: '4:35' },
			{ id: 6, title: 'Ad Noctum', length: '4:22' },
			{ id: 7, title: 'Winter Millenium', length: '5:44' },
			{ id: 8, title: 'Fields of Long Gone Presence / Outro', length: '2:18' },
		],
	},
	{
		id: 10073,
		cover: images.borknagar4,
		year: 2000,
		album: 'Quintessence',
		albumSongs: [
			{ id: 1, title: 'Rivalry of Phantoms', length: '4:36' },
			{ id: 2, title: 'The Presence Is Ominous', length: '4:55' },
			{ id: 3, title: 'Ruins of the Future', length: '4:55' },
			{ id: 4, title: 'Colossus', length: '4:27' },
			{ id: 5, title: 'Inner Landscape', length: '2:51' },
			{ id: 6, title: 'Invincible', length: '4:25' },
			{ id: 7, title: 'Icon Dreams', length: '4:32' },
			{ id: 8, title: 'Genesis Torn', length: '5:16' },
			{ id: 9, title: 'Embers', length: '1:26' },
			{ id: 10, title: 'Revolt', length: '6:05' },
		],
	},
	{
		id: 10074,
		cover: images.borknagar5,
		year: 2001,
		album: 'Empiricism',
		albumSongs: [
			{ id: 1, title: 'The Genuine Pulse', length: '4:51' },
			{ id: 2, title: 'Gods of My World', length: '4:25' },
			{ id: 3, title: 'The Black Canvas', length: '5:18' },
			{ id: 4, title: 'Matter and Motion', length: '2:30' },
			{ id: 5, title: 'Soul Sphere', length: '6:40' },
			{ id: 6, title: 'Inherit the Earth', length: '5:29' },
			{ id: 7, title: 'The Stellar Dome', length: '5:36' },
			{ id: 8, title: 'Four Element Synchronicity', length: '5:51' },
			{ id: 9, title: 'Liberated', length: '4:51' },
			{ id: 10, title: 'The View of Everlast', length: '4:28' },
		],
	},
	{
		id: 10075,
		cover: images.borknagar6,
		year: 2004,
		album: 'Epic',
		albumSongs: [
			{ id: 1, title: 'Future Reminiscence', length: '5:26' },
			{ id: 2, title: 'Traveller', length: '5:03' },
			{ id: 3, title: 'Origin', length: '4:58' },
			{ id: 4, title: 'Sealed Chambers of Electricity', length: '4:12' },
			{ id: 5, title: 'The Weight of Wind', length: '3:58' },
			{ id: 6, title: 'Resonance', length: '4:28' },
			{ id: 7, title: 'Relate (Dialogue)', length: '4:28' },
			{ id: 8, title: 'Cyclus', length: '5:25' },
			{ id: 9, title: 'Circled', length: '4:45' },
			{ id: 10, title: 'The Inner Ocean Hypothesis', length: '5:10' },
			{ id: 11, title: 'Quintessence', length: '5:31' },
			{ id: 12, title: 'The Wonder', length: '4:16' },
		],
	},
	{
		id: 10076,
		cover: images.borknagar7,
		year: 2006,
		album: 'Origin',
		albumSongs: [
			{ id: 1, title: 'Earth Imagery', length: '4:52' },
			{ id: 2, title: 'Grains', length: '3:42' },
			{ id: 3, title: 'Oceans Rise', length: '6:05' },
			{ id: 4, title: 'Signs', length: '1:17' },
			{ id: 5, title: 'White', length: '4:45' },
			{ id: 6, title: 'Cynosure', length: '2:55' },
			{ id: 7, title: 'The Human Nature', length: '4:48' },
			{ id: 8, title: 'Acclimation', length: '4:30' },
			{ id: 9, title: 'The Spirit of Nature', length: '3:00' },
		],
	},
	{
		id: 10077,
		cover: images.borknagar8,
		year: 2010,
		album: 'Universal',
		albumSongs: [
			{ id: 1, title: 'Havoc', length: '6:42' },
			{ id: 2, title: 'Reason', length: '6:55' },
			{ id: 3, title: 'The Stir of Seasons', length: '4:01' },
			{ id: 4, title: 'For a Thousand Years to Come', length: '6:46' },
			{ id: 5, title: 'Abrasion Tide', length: '7:14' },
			{ id: 6, title: 'Fleshflower', length: '3:28' },
			{ id: 7, title: 'Worldwide', length: '6:59' },
			{ id: 8, title: 'My Domain', length: '4:49' },
		],
	},

	{
		id: 10078,
		cover: images.borknagar9,
		year: 2012,
		album: 'Urd',
		albumSongs: [
			{ id: 1, title: 'Epochalypse', length: '6:08' },
			{ id: 2, title: 'Roots', length: '5:55' },
			{ id: 3, title: 'The Beauty of Dead Cities', length: '4:15' },
			{ id: 4, title: 'The Earthling', length: '6:51' },
			{ id: 5, title: 'The Plains of Memories', length: '4:27' },
			{ id: 6, title: 'Mount Regency', length: '6:08' },
			{ id: 7, title: 'Frostrite', length: '4:50' },
			{ id: 8, title: 'The Winter Eclipse', length: '8:45' },
			{ id: 9, title: 'In a Deeper World', length: '5:42' },
		],
	},
	{
		id: 10079,
		cover: images.borknagar10,
		year: 2016,
		album: 'Winter Thrice',
		albumSongs: [
			{ id: 1, title: 'The Rhymes of the Mountain', length: '6:41' },
			{ id: 2, title: 'Winter Thrice', length: '6:13' },
			{ id: 3, title: 'Cold Runs the River', length: '5:52' },
			{ id: 4, title: 'Panorama', length: '5:51' },
			{ id: 5, title: 'When Chaos Calls', length: '7:02' },
			{ id: 6, title: 'Erodent', length: '6:56' },
			{ id: 7, title: 'Noctilucent', length: '3:54' },
			{ id: 8, title: 'Terminus', length: '7:07' },
			{ id: 9, title: 'Dominant Winds', length: '7:18' },
		],
	},
	{
		id: 10080,
		cover: images.borknagar11,
		year: 2019,
		album: 'True North',
		albumSongs: [
			{ id: 1, title: 'Thunderous', length: '8:34' },
			{ id: 2, title: 'Up North', length: '6:29' },
			{ id: 3, title: 'The Fire That Burns', length: '6:38' },
			{ id: 4, title: 'Lights', length: '5:04' },
			{ id: 5, title: "Wild Father's Heart", length: '5:42' },
			{ id: 6, title: 'Mount Rapture', length: '6:08' },
			{ id: 7, title: 'Into the White', length: '5:57' },
			{ id: 8, title: 'Tidal', length: '9:32' },
			{ id: 9, title: 'Voices', length: '5:07' },
		],
	},
	{
		id: 10081,
		cover: images.borknagar1,
		year: 2024,
		album: 'Fall',
		albumSongs: [
			{ id: 1, title: 'Summits', length: '7:58' },
			{ id: 2, title: 'Nordic Anthem', length: '5:14' },
			{ id: 3, title: 'Afar', length: '6:54' },
			{ id: 4, title: 'Moon', length: '5:51' },
			{ id: 5, title: 'Stars Ablaze', length: '8:26' },
			{ id: 6, title: 'Unraveling', length: '4:33' },
			{ id: 7, title: 'The Wild Lingers', length: '5:34' },
			{ id: 8, title: 'Northward', length: '9:54' },
		],
	},
	/*BLOOD INCANTATION ALBULS*/
	{
		id: 10052,
		cover: images.bloodincantation5,
		year: 2016,
		album: 'Starspawn',
		albumSongs: [
			{ id: 1, title: 'Vitrification of Blood (Part I)', length: '13:04' },
			{ id: 2, title: 'Chaoplasm', length: '5:29' },
			{ id: 3, title: 'Hidden Species (Vitrification of Blood Part 2)', length: '6:56' },
			{ id: 4, title: 'Meticulous Soul Devourment', length: '4:13' },
			{ id: 5, title: 'Starspawn', length: '4:14' },
		],
	},
	{
		id: 10053,
		cover: images.bloodincantation4,
		year: 2019,
		album: 'Hidden History of the Human Race',
		albumSongs: [
			{ id: 1, title: 'Slave Species of the Gods', length: '5:31' },
			{ id: 2, title: 'The Giza Power Plant', length: '7:06' },
			{ id: 3, title: 'Inner Paths (to Outer Space)', length: '5:38' },
			{
				id: 4,
				title:
					'Awakening From the Dream of Existence to the Multidimensional Nature of Our Reality (Mirror of the Soul)',
				length: '18:05',
			},
		],
	},
	{
		id: 10054,
		cover: images.bloodincantation3,
		year: 2022,
		album: 'Timewave Zero',
		albumSongs: [
			{ id: 1, title: 'Io: First Movement', length: '7:05' },
			{ id: 2, title: 'Io: Second Movement', length: '4:58' },
			{ id: 3, title: 'Io: Third Movement', length: '5:30' },
			{ id: 4, title: 'Io: Fourth Movement', length: '3:23' },
			{ id: 5, title: 'Ea: First Movement', length: '7:21' },
			{ id: 6, title: 'Ea: Second Movement', length: '2:23' },
			{ id: 7, title: 'Ea: Third Movement', length: '5:34' },
			{ id: 8, title: 'Ea: Fourth Movement', length: '4:21' },
		],
	},
	{
		id: 10056,
		cover: images.bloodincantation1,
		year: 2024,
		album: 'Absolute Elsewhere',
		albumSongs: [
			{ id: 1, title: 'The Stargate [Tablet I]', length: '8:20' },
			{ id: 2, title: 'The Stargate [Tablet II]', length: '5:08' },
			{ id: 3, title: 'The Stargate [Tablet III]', length: '6:51' },
			{ id: 4, title: 'The Message [Tablet I]', length: '5:57' },
			{ id: 5, title: 'The Message [Tablet II]', length: '5:59' },
			{ id: 6, title: 'The Message [Tablet III]', length: '11:28' },
		],
	},
	{
		id: 10057,
		cover: images.bloodincantation2,
		year: 2026,
		album: 'All Gates Open (Original Motion Picture Soundtrack)',
		albumSongs: [
			{ id: 1, title: 'Balance', length: '20:47' },
			{ id: 2, title: 'Flight', length: '20:37' },
			{ id: 3, title: 'Dawn', length: '5:43' },
			{ id: 4, title: 'Rain', length: '13:43' },
		],
	},

	/*Depeche Mode Albums*/
	{
		id: 40000,
		cover: images.depeche_mode1,
		year: 2023,
		album: 'Memento Mori',
		albumSongs: [
			{ id: 1, title: 'My Cosmos Is Mine', length: '5:02' },
			{ id: 2, title: 'Wagging Tongue', length: '4:10' },
			{ id: 3, title: "Don't Say You Love Me", length: '4:15' },
			{ id: 4, title: 'My Favourite Stranger', length: '4:24' },
			{ id: 5, title: 'Soul With Me', length: '4:04' },
			{ id: 6, title: "Caroline's Monkey", length: '4:22' },
			{ id: 7, title: 'Before We Drown', length: '4:31' },
			{ id: 8, title: 'Always You', length: '3:41' },
			{ id: 9, title: 'People Are Good', length: '4:15' },
			{ id: 10, title: 'Speak to Me', length: '6:15' },
			{ id: 11, title: 'Ghosts Again', length: '3:34' },
			{ id: 12, title: 'Never Let Me Go', length: '5:57' },
		],
	},
	{
		id: 40001,
		cover: images.depeche_mode2,
		year: 2017,
		album: 'Spirit',
		albumSongs: [
			{ id: 1, title: 'Going Backwards', length: '5:15' },
			{ id: 2, title: "Where's the Revolution", length: '4:22' },
			{ id: 3, title: 'The Worst Crime', length: '5:16' },
			{ id: 4, title: 'Scum', length: '4:20' },
			{ id: 5, title: 'You Move', length: '4:38' },
			{ id: 6, title: 'Cover Me', length: '5:16' },
			{ id: 7, title: 'Eternal', length: '3:47' },
			{ id: 8, title: 'Poison Heart', length: '4:38' },
			{ id: 9, title: 'So Much Love', length: '3:39' },
			{ id: 10, title: 'Poorman', length: '4:35' },
			{ id: 11, title: 'No More (This Is the Last Time)', length: '4:20' },
			{ id: 12, title: 'Fail', length: '5:16' },
		],
	},
	{
		id: 40002,
		cover: images.depeche_mode3,
		year: 2013,
		album: 'Delta Machine',
		albumSongs: [
			{ id: 1, title: 'Welcome to My World', length: '5:11' },
			{ id: 2, title: 'Angel', length: '4:47' },
			{ id: 3, title: 'Heaven', length: '4:27' },
			{ id: 4, title: 'Secret to the End', length: '5:00' },
			{ id: 5, title: 'My Little Universe', length: '3:38' },
			{ id: 6, title: 'Slow', length: '5:10' },
			{ id: 7, title: 'Broken', length: '4:16' },
			{ id: 8, title: 'The Child Inside', length: '4:37' },
			{ id: 9, title: 'Soft Touch/Raw Nerve', length: '5:13' },
			{ id: 10, title: 'Should Be Higher', length: '5:20' },
			{ id: 11, title: 'Alone', length: '3:54' },
			{ id: 12, title: 'Soothe My Soul', length: '3:59' },
			{ id: 13, title: 'Goodbye', length: '4:11' },
			{ id: 14, title: 'Long Time Lie', length: '4:33' },
		],
	},
	{
		id: 40003,
		cover: images.depeche_mode4,
		year: 2009,
		album: 'Sounds of the Universe',
		albumSongs: [
			{ id: 1, title: 'In Chains', length: '6:10' },
			{ id: 2, title: 'Hole to Feed', length: '3:33' },
			{ id: 3, title: 'Wrong', length: '4:16' },
			{ id: 4, title: 'Fragile Tension', length: '4:36' },
			{ id: 5, title: 'Little Soul', length: '3:20' },
			{ id: 6, title: 'In Sympathy', length: '4:19' },
			{ id: 7, title: 'Peace', length: '4:41' },
			{ id: 8, title: 'Come Back', length: '4:38' },
			{ id: 9, title: 'Spacewalker', length: '2:07' },
			{ id: 10, title: 'Jezebel', length: '4:19' },
			{ id: 11, title: 'Corrupt', length: '5:20' },
			{ id: 12, title: 'Perfect', length: '4:22' },
		],
	},
	{
		id: 40004,
		cover: images.depeche_mode5,
		year: 2005,
		album: 'Playing the Angel',
		albumSongs: [
			{ id: 1, title: "A Pain That I'm Used To", length: '4:23' },
			{ id: 2, title: 'John the Revelator', length: '4:10' },
			{ id: 3, title: 'Suffer Well', length: '3:58' },
			{ id: 4, title: 'The Sinner in Me', length: '5:15' },
			{ id: 5, title: 'Precious', length: '4:12' },
			{ id: 6, title: 'Macro', length: '4:36' },
			{ id: 7, title: 'I Want It All', length: '5:16' },
			{ id: 8, title: "Nothing's Impossible", length: '5:03' },
			{ id: 9, title: 'Introspectre', length: '2:37' },
			{ id: 10, title: 'Damaged People', length: '4:15' },
			{ id: 11, title: 'Lilian', length: '4:44' },
			{ id: 12, title: 'The Darkest Star', length: '6:11' },
		],
	},
	{
		id: 40005,
		cover: images.depeche_mode6,
		year: 2001,
		album: 'Exciter',
		albumSongs: [
			{ id: 1, title: 'Dream On', length: '4:41' },
			{ id: 2, title: 'Shine', length: '5:22' },
			{ id: 3, title: 'The Sweetest Condition', length: '4:23' },
			{ id: 4, title: 'When the Body Speaks', length: '5:38' },
			{ id: 5, title: 'The Dead of Night', length: '4:32' },
			{ id: 6, title: 'Lovetheme', length: '2:29' },
			{ id: 7, title: 'Freelove', length: '5:22' },
			{ id: 8, title: 'Comatose', length: '5:12' },
			{ id: 9, title: 'I Feel Loved', length: '4:38' },
			{ id: 10, title: 'Breathe', length: '4:12' },
			{ id: 11, title: 'Easy Tiger', length: '2:56' },
			{ id: 12, title: 'I Want It All', length: '4:33' },
		],
	},
	{
		id: 40006,
		cover: images.depeche_mode7,
		year: 1997,
		album: 'Ultra',
		albumSongs: [
			{ id: 1, title: 'Barrel of a Gun', length: '3:52' },
			{ id: 2, title: 'The Love Thieves', length: '4:36' },
			{ id: 3, title: 'Home', length: '5:24' },
			{ id: 4, title: "It's No Good", length: '4:33' },
			{ id: 5, title: 'Uselink', length: '1:03' },
			{ id: 6, title: 'Sister of Night', length: '5:24' },
			{ id: 7, title: 'Jazz Thieves', length: '1:03' },
			{ id: 8, title: 'Useless', length: '4:44' },
			{ id: 9, title: 'Sound of Silence', length: '4:59' },
			{ id: 10, title: 'Insight', length: '4:33' },
			{ id: 11, title: 'Freestate', length: '4:41' },
			{ id: 12, title: 'The Bottom Line', length: '5:36' },
			{ id: 13, title: 'Junior Painkiller', length: '2:03' },
		],
	},
	{
		id: 40007,
		cover: images.depeche_mode8,
		year: 1993,
		album: 'Songs of Faith and Devotion',
		albumSongs: [
			{ id: 1, title: 'I Feel You', length: '5:22' },
			{ id: 2, title: 'Walking in My Shoes', length: '5:59' },
			{ id: 3, title: 'Condemnation', length: '5:19' },
			{ id: 4, title: 'Mercy in You', length: '5:29' },
			{ id: 5, title: 'Judas', length: '6:10' },
			{ id: 6, title: 'In Your Room', length: '6:37' },
			{ id: 7, title: 'Get Right with Me', length: '3:53' },
			{ id: 8, title: 'Rush', length: '4:32' },
			{ id: 9, title: 'One Caress', length: '4:26' },
			{ id: 10, title: 'Higher Love', length: '6:31' },
		],
	},
	{
		id: 40008,
		cover: images.depeche_mode9,
		year: 1990,
		album: 'Violator',
		albumSongs: [
			{ id: 1, title: 'World in My Eyes', length: '4:23' },
			{ id: 2, title: 'Sweetest Perfection', length: '5:28' },
			{ id: 3, title: 'Personal Jesus', length: '4:56' },
			{ id: 4, title: 'Halo', length: '4:29' },
			{ id: 5, title: 'Waiting for the Night', length: '6:04' },
			{ id: 6, title: 'Enjoy the Silence', length: '6:12' },
			{ id: 7, title: 'Policy of Truth', length: '4:55' },
			{ id: 8, title: 'Blue Dress', length: '5:19' },
			{ id: 9, title: 'Clean', length: '5:32' },
		],
	},
	{
		id: 40009,
		cover: images.depeche_mode10,
		year: 1987,
		album: 'Music for the Masses',
		albumSongs: [
			{ id: 1, title: 'Never Let Me Down Again', length: '4:55' },
			{ id: 2, title: 'The Things You Said', length: '4:18' },
			{ id: 3, title: 'Strangelove', length: '4:17' },
			{ id: 4, title: 'Sacred', length: '4:12' },
			{ id: 5, title: 'Little 15', length: '3:50' },
			{ id: 6, title: 'Behind the Wheel', length: '5:07' },
			{ id: 7, title: 'I Want You Now', length: '3:34' },
			{ id: 8, title: 'To Have and to Hold', length: '4:52' },
			{ id: 9, title: 'Nothing', length: '4:24' },
			{ id: 10, title: 'Pimpf', length: '4:44' },
		],
	},
	{
		id: 40010,
		cover: images.depeche_mode11,
		year: 1986,
		album: 'Black Celebration',
		albumSongs: [
			{ id: 1, title: 'Black Celebration', length: '5:07' },
			{ id: 2, title: 'Fly on the Windscreen – Final', length: '5:47' },
			{ id: 3, title: 'A Question of Lust', length: '4:20' },
			{ id: 4, title: 'Sometimes', length: '2:53' },
			{ id: 5, title: "It Doesn't Matter Two", length: '4:12' },
			{ id: 6, title: 'A Question of Time', length: '4:16' },
			{ id: 7, title: 'Stripped', length: '4:16' },
			{ id: 8, title: 'Here Is the House', length: '5:29' },
			{ id: 9, title: 'World Full of Nothing', length: '4:20' },
			{ id: 10, title: 'Dressed in Black', length: '2:37' },
			{ id: 11, title: 'New Dress', length: '4:40' },
		],
	},
	{
		id: 40011,
		cover: images.depeche_mode12,
		year: 1984,
		album: 'Some Great Reward',
		albumSongs: [
			{ id: 1, title: 'Something to Do', length: '4:20' },
			{ id: 2, title: 'Lie to Me', length: '4:52' },
			{ id: 3, title: 'People Are People', length: '3:37' },
			{ id: 4, title: "It Doesn't Matter", length: '4:20' },
			{ id: 5, title: 'Stories of Old', length: '3:22' },
			{ id: 6, title: 'Somebody', length: '3:07' },
			{ id: 7, title: 'Master and Servant', length: '3:57' },
			{ id: 8, title: 'If You Want', length: '4:20' },
			{ id: 9, title: 'Blasphemous Rumours', length: '6:34' },
		],
	},
	{
		id: 40012,
		cover: images.depeche_mode13,
		year: 1983,
		album: 'Construction Time Again',
		albumSongs: [
			{ id: 1, title: 'Love, In Itself', length: '4:08' },
			{ id: 2, title: 'More Than a Party', length: '4:53' },
			{ id: 3, title: 'Pipeline', length: '5:38' },
			{ id: 4, title: 'Everything Counts', length: '4:11' },
			{ id: 5, title: 'Two Minute Warning', length: '4:12' },
			{ id: 6, title: 'Shame', length: '4:16' },
			{ id: 7, title: 'The Landscape Is Changing', length: '4:31' },
			{ id: 8, title: 'Told You So', length: '4:16' },
			{ id: 9, title: 'And Then...', length: '5:16' },
		],
	},
	{
		id: 40013,
		cover: images.depeche_mode14,
		year: 1982,
		album: 'A Broken Frame',
		albumSongs: [
			{ id: 1, title: 'Leave in Silence', length: '4:47' },
			{ id: 2, title: 'My Secret Garden', length: '4:11' },
			{ id: 3, title: 'Monument', length: '3:32' },
			{ id: 4, title: 'Nothing to Fear', length: '4:02' },
			{ id: 5, title: 'See You', length: '3:53' },
			{ id: 6, title: 'Satellite', length: '4:26' },
			{ id: 7, title: 'The Meaning of Love', length: '3:15' },
			{ id: 8, title: 'A Photograph of You', length: '3:03' },
			{ id: 9, title: "Shouldn't Have Done That", length: '3:15' },
			{ id: 10, title: 'The Sun and the Rainfall', length: '4:32' },
		],
	},
	{
		id: 40014,
		cover: images.depeche_mode15,
		year: 1981,
		album: 'Speak & Spell',
		albumSongs: [
			{ id: 1, title: 'New Life', length: '4:34' },
			{ id: 2, title: 'I Sometimes Wish I Was Dead', length: '2:29' },
			{ id: 3, title: 'Puppets', length: '3:33' },
			{ id: 4, title: 'Boys Say Go!', length: '3:15' },
			{ id: 5, title: 'Nodisco', length: '3:55' },
			{ id: 6, title: "What's Your Name?", length: '2:38' },
			{ id: 7, title: 'Photographic', length: '4:08' },
			{ id: 8, title: 'Tora! Tora! Tora!', length: '5:03' },
			{ id: 9, title: 'Big Muff', length: '4:52' },
			{ id: 10, title: 'Any Second Now (Voices)', length: '2:32' },
			{ id: 11, title: "Just Can't Get Enough", length: '3:45' },
		],
	},
]
